import { PageWrapper } from '@/shared'

import style from './InitialPage.module.scss'

export const InitialPage = () => {
    const header = 'Стартовая страница'
    const title =
        'По вопросам получения дополнительных прав ДМС администратора,\nна редактирования врачей и отзывов необходимо обратиться к Ремизенцевой Екатерине'
    return (
        <div className={style.container}>
            <PageWrapper>
                {/* TODO: Поместить в дочерние компоненты */}
                <h2>{header}</h2>
                <h3>{title}</h3>
            </PageWrapper>
        </div>
    )
}
